<template lang="pug">
.filters
  layout-filter(
    @change="applyFilter('layout', $event)"
    :layout="data.layout"
    @applyFilters="applyFilters"
  )
  area-filter(
    @change="applyFilter('area', $event)"
    :min="data.area.min"
    :max="data.area.max"
    @applyFilters="applyFilters"
  )
  time-to-nearest-station-filter(
    @change="applyFilter('timeNearestStation', $event)"
    :timeNearestStation="data.timeNearestStation"
    @applyFilters="applyFilters"
  )
  building-structure-filter(
    @change="applyFilter('buildingStructure', $event)"
    :buildingStructure="data.buildingStructure"
    @applyFilters="applyFilters"
  )
  age-filter(
    @change="applyFilter('age', $event)"
    :age="data.age"
    @applyFilters="applyFilters"
  )
  basic-unit-price-filter(
    @change="applyFilter('basicUnitPrice', $event)"
    :min="data.basicUnitPrice.min"
    :max="data.basicUnitPrice.max"
    @applyFilters="applyFilters"
  )
  rent-fee-filter(
    @change="applyFilter('rentFee', $event)"
    :min="data.rentFee.min"
    :max="data.rentFee.max"
    @applyFilters="applyFilters"
  )
  ota-site-filter(
    @change="applyFilter('otaSite', $event)"
    :otaSite="data.otaSite"
    @applyFilters="applyFilters"
  )
  radius-filter(
    @change="applyFilter('radius', $event)"
    :radius="data.radius"
    @applyFilters="applyFilters"
  )
  facilities-filter(
    @change="applyFilter('facilities', $event)"
    :facilities="data.facilities"
    @applyFilters="applyFilters"
  )
</template>

<script>
  import LayoutFilter from "./filters/layout-filter"
  import AreaFilter from "./filters/area-filter"
  import TimeToNearestStationFilter from "./filters/time-to-nearest-station-filter"
  import BuildingStructureFilter from "./filters/building-structure-filter"
  import AgeFilter from "./filters/age-filter"
  import BasicUnitPriceFilter from "./filters/basic-unit-price-filter"
  import RentFeeFilter from "./filters/rent-fee-filter"
  import OtaSiteFilter from "./filters/ota-site-filter"
  import RadiusFilter from "./filters/radius-filter"
  import FacilitiesFilter from "./filters/facilities-filter"
  import applyFilter from '@/mixins/apply-filter'

  export default {
    components: {
      LayoutFilter,
      AreaFilter,
      TimeToNearestStationFilter,
      BuildingStructureFilter,
      AgeFilter,
      BasicUnitPriceFilter,
      RentFeeFilter,
      OtaSiteFilter,
      RadiusFilter,
      FacilitiesFilter
    },

    mixins: [applyFilter],

    props: {
      filters: {
        type: Object,
        default: () => ({})
      }
    },

    data() {
      return {
        data: this.filters
      }
    },

    mounted() {
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          this.$root.$emit('bv::hide::popover')
        }
      })
    },

    methods: {
      applyFilter(type, value) {
        this.data = { ...this.data, [type]: value }
      },

      applyFilters() {
        this.$emit('change', this.data)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/css/mixins/competitors/filter.scss';

  .filters {
    align-items: center;
    display: flex;
  }

  #apply-filters {
    @include button-item-filter;
  }
</style>
